/**
 * Stable CSS class names for E2E — SearchService batch search modal.
 */
export const SS_BS = {
    modalRoot: 'search-service-batch-modal',
    modalPaper: 'search-service-batch-modal__paper',
    modalTitle: 'search-service-batch-modal__title',
    modalCloseButton: 'search-service-batch-modal-input--button-close',
    modalCloseIcon: 'search-service-batch-modal__close-icon',

    content: 'search-service-batch-modal__content',
    input: 'search-service-batch-modal-input__textarea',
} as const;

export const ssBsCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

